import { AllTimeBestQuarter } from "@shared/models";

/**
 * L8's "Your all-time" card own "Best quarter" line ("Q2 2026 · 85", 923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md).
 * The api returns `year`/`quarter`/`score` raw (`recognitionBestQuarterSchema`'s own JSDoc: "formatting
 * is presentation and the web already owns it") -- this is that formatting, and its only job.
 *
 * @param bestQuarter The viewer's own highest-scoring quarter ever, or `null` for someone with zero
 *   approved, non-deleted received recognitions -- a real, different fact from "scored a 0 quarter".
 * @returns `"Q<quarter> <year> · <score>"`, or `"—"` for `null` -- never a fabricated "Q0 0000 · 0".
 */
export const bestQuarterCopy = (bestQuarter: AllTimeBestQuarter | null): string =>
  bestQuarter ? `Q${bestQuarter.quarter} ${bestQuarter.year} · ${bestQuarter.score}` : "—";
